export const isInputEmpty = (inputName, inputValue) => {
  let newStateObj: any = {[inputName]: inputValue};
  newStateObj[`${inputName}Error`] = !inputValue.length;

  return newStateObj;
}